<script>
  import { useLocation, Link } from "svelte-navigator";
  import { SUPPORTED_LANGUAGES } from "./languages.js";

  /**
   * Hyperlink reference target.
   * This link will be prefixed with language if the source location is language-prefixed.
   * @type {string}
   */
  export let href

  /**
   * If true, apply "text-decoration: underline".
   * @type {boolean}
   */
  export let underline = false

  const location = useLocation()

  let link = href
  $: {
    const pathname = $location.pathname

    let prefixCurrent = null
    let prefixDest = null
    // determine if the current path and the destination are language-prefixed
    for (const language of SUPPORTED_LANGUAGES) {
      if (pathname.startsWith(`/${language}`)) {
        prefixCurrent = language
      }
      if (href.startsWith(`/${language}`)) {
        prefixDest = language
      }
    }
    if (prefixCurrent && !prefixDest) link = `/${prefixCurrent}` + href
    else link = href
  }
</script>

<Link to={link} class={underline ? "underline" : ""}>
  <slot />
</Link>

<style>
  :global(.underline) {
    text-decoration: underline;
  }
</style>
